module.exports = __webpack_public_path__ + "img/r.f01ff909.jpg";